export default __webpack_public_path__ + "slices/main/assets/public/media/qualtrics-logo.33ef3bc217402b92799e98c5fb156038.png";